// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WNDw","fullView":"styles_fullView__dEHNT"};